/* eslint-disable import/prefer-default-export */
export const BIODATAFORMAT = {
  invitro: {
    headers: [
      {
        id: 'paureus',
        order: 0,
        title: 'pX',
      },
      {
        id: 'parameter',
        order: 1,
        title: 'Parameter',
      },
      {
        id: 'qualitativeValue',
        order: 2,
        title: 'Value (qual)',
      },
      {
        id: 'quantitativeValue',
        order: 3,
        title: 'Value (quant)',
      },
      {
        id: 'unit',
        order: 4,
        title: 'Unit',
      },
      {
        id: 'bioSpecies',
        order: 5,
        title: 'Biological Species',
      },
      {
        id: 'targetAction',
        order: 6,
        title: 'Action on target',
      },
      {
        id: 'targets',
        order: 7,
        title: 'Target',
      },
      {
        id: 'population',
        order: 8,
        title: '(Clinical) findings / disease',
      },
      {
        id: 'tissueOrgan',
        order: 9,
        title: 'Tissue/Organ',
      },
      {
        id: 'cell',
        order: 10,
        title: 'Cell',
      },
      {
        id: 'bioassay',
        order: 11,
        title: 'Bioassay',
      },
      {
        id: 'dose',
        order: 12,
        title: 'Dose',
      },
      {
        id: 'effect',
        order: 13,
        title: 'Effect',
      },
      {
        id: 'concomitants',
        order: 14,
        title: 'Concomitants',
      },
      {
        id: 'metabolites',
        order: 15,
        title: 'Metabolites',
      },
      {
        id: 'citations',
        order: 16,
        title: 'Reference',
      },
    ],
  },
  invivo: {
    headers: [
      {
        id: 'paureus',
        order: 0,
        title: 'pX',
      },
      {
        id: 'parameter',
        order: 1,
        title: 'Parameter',
      },
      {
        id: 'qualitativeValue',
        order: 2,
        title: 'Value (qual)',
      },
      {
        id: 'quantitativeValue',
        order: 3,
        title: 'Value (quant)',
      },
      {
        id: 'unit',
        order: 4,
        title: 'Unit',
      },
      {
        id: 'bioSpecies',
        order: 5,
        title: 'Biological Species',
      },
      {
        id: 'population',
        order: 6,
        title: '(Clinical) findings / disease',
      },
      {
        id: 'animalModel',
        order: 7,
        title: 'Animal Model',
      },
      {
        id: 'adminRoute',
        order: 8,
        title: 'Route of administration',
      },
      {
        id: 'dose',
        order: 9,
        title: 'Dose',
      },
      {
        id: 'doseRegimen',
        order: 10,
        title: 'Dosing regimen',
      },
      {
        id: 'effect',
        order: 11,
        title: 'Effect',
      },
      {
        id: 'concomitants',
        order: 12,
        title: 'Concomitants',
      },
      {
        id: 'metabolites',
        order: 13,
        title: 'Metabolites',
      },
      {
        id: 'citations',
        order: 14,
        title: 'Reference',
      },
    ],
  },
  meta: {
    headers: [
      {
        id: 'paureus',
        order: 0,
        title: 'pX',
      },
      {
        id: 'parameter',
        order: 1,
        title: 'Parameter',
      },
      {
        id: 'qualitativeValue',
        order: 2,
        title: 'Value (qual)',
      },
      {
        id: 'quantitativeValue',
        order: 3,
        title: 'Value (quant)',
      },
      {
        id: 'unit',
        order: 4,
        title: 'Unit',
      },
      {
        id: 'bioSpecies',
        order: 5,
        title: 'Biological Species',
      },
      {
        id: 'targetAction',
        order: 6,
        title: 'Action on target',
      },
      {
        id: 'targets',
        order: 7,
        title: 'Target',
      },
      {
        id: 'population',
        order: 8,
        title: '(Clinical) findings / disease',
      },
      {
        id: 'tissueOrgan',
        order: 9,
        title: 'Tissue/Organ',
      },
      {
        id: 'cell',
        order: 10,
        title: 'Cell',
      },
      {
        id: 'cellFraction',
        order: 11,
        title: 'Cell fraction',
      },
      {
        id: 'substrateCarriedMolecule',
        order: 12,
        title: 'Substrate / Carried Molecule',
      },
      {
        id: 'dose',
        order: 13,
        title: 'Dose',
      },
      {
        id: 'concomitants',
        order: 14,
        title: 'Concomitants',
      },
      {
        id: 'metabolites',
        order: 15,
        title: 'Metabolites',
      },
      {
        id: 'citations',
        order: 16,
        title: 'Reference',
      },
    ],
  },
  pharm: {
    headers: [
      {
        id: 'paureus',
        order: 0,
        title: 'pX',
      },
      {
        id: 'parameter',
        order: 1,
        title: 'Parameter',
      },
      {
        id: 'qualitativeValue',
        order: 2,
        title: 'Value (qual)',
      },
      {
        id: 'quantitativeValue',
        order: 3,
        title: 'Value (quant)',
      },
      {
        id: 'unit',
        order: 4,
        title: 'Unit',
      },
      {
        id: 'bioSpecies',
        order: 5,
        title: 'Biological Species',
      },
      {
        id: 'population',
        order: 6,
        title: '(Clinical) findings / disease',
      },
      {
        id: 'adminRoute',
        order: 7,
        title: 'Route of administration',
      },
      {
        id: 'dose',
        order: 8,
        title: 'Dose',
      },
      {
        id: 'doseRegimen',
        order: 9,
        title: 'Dosing regimen',
      },
      {
        id: 'concomitants',
        order: 10,
        title: 'Concomitants',
      },
      {
        id: 'metabolites',
        order: 11,
        title: 'Metabolites',
      },
      {
        id: 'citations',
        order: 12,
        title: 'Reference',
      },
    ],
  },
  toxy: {
    headers: [
      {
        id: 'paureus',
        order: 0,
        title: 'pX',
      },
      {
        id: 'parameter',
        order: 1,
        title: 'Parameter',
      },
      {
        id: 'qualitativeValue',
        order: 2,
        title: 'Value (qual)',
      },
      {
        id: 'quantitativeValue',
        order: 3,
        title: 'Value (quant)',
      },
      {
        id: 'unit',
        order: 4,
        title: 'Unit',
      },
      {
        id: 'bioSpecies',
        order: 5,
        title: 'Biological Species',
      },
      {
        id: 'targetAction',
        order: 6,
        title: 'Action on target',
      },
      {
        id: 'targets',
        order: 7,
        title: 'Target',
      },
      {
        id: 'population',
        order: 8,
        title: '(Clinical) findings / disease',
      },
      {
        id: 'tissueOrgan',
        order: 9,
        title: 'Tissue/Organ',
      },
      {
        id: 'cell',
        order: 10,
        title: 'Cell',
      },
      {
        id: 'bioassay',
        order: 11,
        title: 'Bioassay',
      },
      {
        id: 'dose',
        order: 12,
        title: 'Dose',
      },
      {
        id: 'effect',
        order: 13,
        title: 'Effect',
      },
      {
        id: 'concomitants',
        order: 14,
        title: 'Concomitants',
      },
      {
        id: 'metabolites',
        order: 15,
        title: 'Metabolites',
      },
      {
        id: 'citations',
        order: 16,
        title: 'Reference',
      },
    ],
  },
};
